/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * Controls how multiple bot images are cycled.

- `auto`: Cycles through images at the interval specified by image_duration.
- `bot_status`: Uses the first image when the bot joins, the second image when recording starts, and the third image when recording is paused. If no third image is provided, the bot stays on the recording image during pause. Only the first three images are used in this mode; additional images are ignored.
 */
export type UpdateCalendarBotRequestBodyAllOfTwoBotImageConfigAnyOfLoopMode =
  (typeof UpdateCalendarBotRequestBodyAllOfTwoBotImageConfigAnyOfLoopMode)[keyof typeof UpdateCalendarBotRequestBodyAllOfTwoBotImageConfigAnyOfLoopMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCalendarBotRequestBodyAllOfTwoBotImageConfigAnyOfLoopMode = {
  auto: "auto",
  bot_status: "bot_status"
} as const
